export enum PageLocation {
  NONE = 0,
  HISTORY,
  NEWS_UPLOAD,
  CLASSIFICATION,
  REPORT_REVISION,
  BATCH_CORRECTION,
  JOURNALIST_INPUT,
  JOURNALIST_SEARCH,
  VEHICLE_INPUT,
  VEHICLE_EDIT,
  VEHICLE_SEARCH,
  USER_INPUT,
  USER_EDIT,
  USER_SEARCH,
  CLIENT_INPUT,
  CLIENT_EDIT,
  CLIENT_SEARCH,
  NEWS_METRIC_IDS,
  CLIPPER_INPUT,
  CLIPPER_EDIT,
  CLIPPER_SEARCH,
  DETACHED_CLASSIFICATION_INITIAL,
  DETACHED_CLASSIFICATION,
  SOCIAL_MEDIA_UPLOAD,
  KEYWORD_INCLUSION,
  DASHBOARD,
  INFLUENCER_UPLOAD,
  INFLUENCER_SUBMIT,
  INFLUENCER_CAMPAIGN,
  INFLUENCER_PROFILE_CLASSIFICATION,
  INFLUENCER_CAMPAIGN_CLASSIFICATION,
  INFLUENCER_COMPANY_CLASSIFICATION,
  INFLUENCER_CAMPAIGN_LIST,
  INFLUENCER_COMPANY_LIST,
  INFLUENCER_PROFILE_CONSULT,
  INFLUENCER_CAMPAIGN_CONSULT,
  INFLUENCER_COMPANY_CONSULT,
  INFLUENCER_SINGLE_PROFILE_SUBMIT,
  INFLUENCER_SINGLE_COMPANY_SUBMIT,
  INFLUENCER_SINGLE_CAMPAIGN_SUBMIT,
  INFLUENCER_CLASSIFICATION,
  INFLUENCER_COMPANY,
  INFLUENCER_HISTORY,
  CLASSIFICATION_INFLUENCER,
  INFLUENCER_HOME,
  INFLUENCER_CLIENT_SELECT,
  DASHBOARD_INFLUENCER,
  DASHBOARD_INFLUENCER_BOTICARIO,
  DASHBOARD_COLGATE,
  DASHBOARD_GENERIC,
  FAQ,
}
